import ajax from '../../../../scanline/utils/ajax';

export const getAsset = (template, name, type = 'chart') => {
	return ajax(
		`/asset/history/${template}/${encodeURIComponent(name)}/${type}`,
		undefined,
		'GET',
		undefined,
		false,
		'assetview'
	);
};

export const getGroup = (template, name, type = 'chart', selected) => {
	return ajax(
		`/group/history/${template}/${encodeURIComponent(name)}`,
		JSON.stringify({ selected }),
		'POST',
		undefined,
		false,
		'assetview'
	);
};

// Raw historical-index hits for one asset (no server-computed chart/table settings) —
// backs the CP Asset History Overview + History tabs.
export const getManagerHistory = (template, name) => {
	return ajax(
		`/asset/history/${template}/${encodeURIComponent(name)}/manager`,
		undefined,
		'GET',
		undefined,
		false,
		'assetview'
	);
};

export const getAPI = type => {
	switch (type) {
		case 'asset':
			return getAsset;
		case 'group':
			return getGroup;
		default:
			return null;
	}
};
